import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot,
  RouterStateSnapshot, CanActivateChild } from '@angular/router';
import { AuthService } from "../services/auth.service";
import { RouteInformation } from 'src/app/shared/constants/route-information';

@Injectable({
  providedIn: 'root'
})

export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(
    private authService: AuthService,
    private router: Router) {}
  canActivate() {
    return this.configNavigate();
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.authService.isLoggedIn) {
      this.router.navigate([RouteInformation.loginPage]);
      return false;
    } else {
      const user = this.authService.storagedUser as any;
      if (user !== null && !user.isNew) {
        const permission = route.data.permission && route.data.permission !== null ? route.data.permission : null;
        if (permission === 'GLOBAL' || (permission !== null && user.permissions.indexOf(permission) !== -1)) {
          return true;
        } else {
          this.router.navigate([RouteInformation.unauthorizedPage]);
          return false;
        }
      } else {
        if (user === null) {
          this.router.navigate([RouteInformation.loginPage]);
        } else if (user !== null && user.isNew) {
          this.router.navigate([RouteInformation.registerPage]);
        }
      }
      return false;
    }
  }

  configNavigate() {
    if (!this.authService.isLoggedIn) {
      this.router.navigate([RouteInformation.loginPage]);
      return false;
    } else {
      const user = this.authService.storagedUser as any;
      if (user !== null && !user.isNew) {
        return true;
      } else {
        if (user === null) {
          this.router.navigate([RouteInformation.loginPage]);
        } else if (user !== null && user.isNew) {
          this.router.navigate([RouteInformation.registerPage]);
        }
      }
      return false;
    }
  }

}